import { createElement } from 'react';
import { Button as Button$1 } from '@chakra-ui/react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["children"];

var Button = function Button(props) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return createElement(Button$1, Object.assign({}, rest), children);
};

export default Button;